import styles from "./Card.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";

/**
 *
 * A card
 */

export function Card({ title, buttonName, children, buttonDisabled, onClick }) {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.title}>{title}</div>

        {buttonName &&
          (buttonDisabled ? (
            <div className={classNames(styles.button, styles.disabled)}>
              {buttonName}
            </div>
          ) : (
            <div className={styles.button} onClick={onClick}>
              {buttonName}
            </div>
          ))}
      </div>

      {/* <div className={styles.hr} /> */}

      {children}
    </div>
  );
}

Card.propTypes = {
  title: PropTypes.string,
  buttonName: PropTypes.string,
  children: PropTypes.object,
  onClick: PropTypes.func,
};
